import request from '@/utils/request'

// 查询主播申请绑定工会记录列表
export function listApplyTradeUnion(query) {
  return request({
    url: '/trade/apply/trade/union/list',
    method: 'get',
    params: query,
  })
}

// 查询主播申请绑定工会记录分页
export function pageApplyTradeUnion(query) {
  return request({
    url: '/trade/apply/trade/union/page',
    method: 'get',
    params: query,
  })
}

// 查询主播申请绑定工会记录详细
export function getApplyTradeUnion(data) {
  return request({
    url: '/trade/apply/trade/union/detail',
    method: 'get',
    params: data,
  })
}

// 新增主播申请绑定工会记录
export function addApplyTradeUnion(data) {
  return request({
    url: '/trade/apply/trade/union/add',
    method: 'post',
    data: data,
  })
}

// 修改主播申请绑定工会记录
export function updateApplyTradeUnion(data) {
  return request({
    url: '/trade/apply/trade/union/edit',
    method: 'post',
    data: data,
  })
}

// 删除主播申请绑定工会记录
export function delApplyTradeUnion(data) {
  return request({
    url: '/trade/apply/trade/union/delete',
    method: 'post',
    data: data,
  })
}
export function bingAudit(data) {
  return request({
    url: '/trade/apply/trade/union/bingAudit',
    method: 'post',
    data: data,
  })
}
export function unBingAudit(data) {
  return request({
    url: '/trade/apply/trade/union/unBingAudit',
    method: 'post',
    data: data,
  })
}
